import { Component, OnInit, Inject } from '@angular/core';
import { AccountService } from '../../../../../services/account.service';
import { CommonfilterService } from 'src/app/services/commonfilter.service';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-license-usage',
  templateUrl: './license-usage.component.html',
  styleUrls: ['./license-usage.component.css']
})
export class LicenseUsageComponent implements OnInit {
  displayedColumns = [ 'status', 'id', 'name', 'type'];
  api_error: any;
  api_success: string;
  disableConfirmbtn = false;
  subscriptionType: any;
  changeSubscriptionText: string;
  subscriptionDetails: any;
  subscriptionMessage: string;
  configData: any = {};
  licSubscriptionTypeDetails: any;
  monthly: any;
  annual: any;
  accId;
  licenseUsage;
  licenseUsageInfo: any;
  lic;
  metrics: any;
  metrices: any;
  constructor(
      private accountService: AccountService, private commonfilter: CommonfilterService, private activatedRoute: ActivatedRoute) {
   }

  ngOnInit() {
    this.activatedRoute.queryParams.subscribe(params => {
      this.accId = params.accountId;
      this.accountService.licenseUsage(this.accId)
      .subscribe(res => {
        this.licenseUsage = res;
        this.lic = this.licenseUsage.BooleanMetricUsageInfo;
        for (let i in this.licenseUsage ) {
          if (i === 'metricUsageInfo') {
          this.metrics = this.licenseUsage[i];
          } else if (i === 'BooleanMetricUsageInfo') {
            this.metrices = this.licenseUsage[i];
          }
        }
      });
    });
   }

}
